import { z } from 'zod'

// Helper to transform empty strings to null (for optional fields)
const nullableString = (maxLength: number) =>
  z
    .string()
    .max(maxLength)
    .transform((val) => (val === '' ? null : val))
    .nullable()
    .optional()

// Helper for nullable number
const nullableNumber = () =>
  z.coerce
    .number()
    .int()
    .positive()
    .or(z.literal('').transform(() => null))
    .nullable()
    .optional()

export const propertySchema = z.object({
  name: z.string().min(1, 'Property name is required').max(255),
  address: z.string().min(1, 'Address is required').max(500),
  city: z.string().min(1, 'City is required').max(100),
  postal_code: z.string().min(1, 'Postal code is required').max(20),
  country: z.string().min(1, 'Country is required').max(100),
  residence_key: z.string().min(1, 'Residence key is required').max(100),
  legal_representative: nullableString(255),
  siret: nullableString(14),
  bank_name: nullableString(255),
  iban: nullableString(34),
  bic: nullableString(11),
  total_shares: nullableNumber(),
})

export type PropertyFormData = z.infer<typeof propertySchema>
